module.exports = __webpack_public_path__ + "img/銀徽章.5fb69121.svg";